import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import hr from "@/i18n/hr.json";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

// The Thank You page is Croatian-only per requirements.
// We read strings directly from the HR bundle so this page is not affected
// by whichever language was active before the redirect.
export default function ThankYou() {
  const c = hr.pages.thank_you;
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header data-nav="true" className="border-b border-border">
        <div className="max-w-[1120px] mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center">
          <Link to="/" aria-label="Arqovena — home" className="text-foreground">
            <Logo className="h-8" />
          </Link>
        </div>
      </header>
      <main className="flex-1">
        <section className="py-20 sm:py-28">
          <div className="max-w-[720px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
              <CheckCircle2 className="h-7 w-7" />
            </div>
            <div className="eyebrow mt-6" data-testid="thank-you-eyebrow">
              {c.eyebrow}
            </div>
            <h1
              className="mt-3 font-display text-4xl sm:text-5xl tracking-[-0.01em] text-foreground"
              data-testid="thank-you-title"
            >
              {c.title}
            </h1>
            <p className="mt-5 text-base sm:text-lg text-muted-foreground max-w-[540px] mx-auto">
              {c.body}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/" data-testid="thank-you-back-home">
                <Button className="h-11 rounded-lg px-6 tracking-[0.06em]">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  {c.back_home}
                </Button>
              </Link>
              <a
                href={`mailto:${c.email}`}
                className="text-sm underline underline-offset-4 decoration-border hover:decoration-primary text-foreground"
                data-testid="thank-you-email"
              >
                {c.email}
              </a>
            </div>
          </div>
        </section>
      </main>
      <footer className="border-t border-border bg-card">
        <div className="max-w-[1120px] mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-muted-foreground flex items-center justify-between">
          <span>{hr.footer.legal.copyright}</span>
          <span className="font-mono-plex tracking-[0.14em] uppercase">arqovena.com</span>
        </div>
      </footer>
    </div>
  );
}
